<div [formGroup]="formGroup">
  <app-select-shareholder
    label="Current Shareholders"
    formControlName="securityRegistryRecordGroup"
    [groupedSecurityRegistryRecords]="groupedSecurityRegistryRecords"
    (select)="onSelectCurrentShareholder($event)"
  />

  @if (formGroup.value.securityRegistryRecordGroup && selectedSecurityGroupHoldersGroupedByName) {
    @if (selectedSecurityGroupHoldersGroupedByName.length && !isBeneficialOwner) {
      <div class="mt-3 mb-1">Shares are owned on behalf of:</div>
    }

    @for (group of selectedSecurityGroupHoldersGroupedByName; track group) {
      @if (!group.value[0].details.isBeneficialOwner) {
        @if (isBeneficialOwnerReadonly || group.value[0].details.beneficialOwner) {
          <div class="form-group">
            <input
              type="text"
              class="readonly-beneficial-owner"
              disabled
              [value]="group.value[0].details.beneficialOwner"
            >
          </div>
        } @else {
          <div class="form-group">
            <app-beneficial-owner
              [controlLike]="true"
              [details]="group.value[0].details"
              [relationshipIds]="group.relationshipIds"
              [showOpenIcon]="false"
              (onDataSaved)="signDataSaved()"
            />

            @if (includesNonBeneficialOwnersNotSignedError && !group.value[0].details.beneficialOwner) {
              <div class="mt-1 color-red font-size-12 font-weight-400 line-height-16">
                {{ customSignErrors.nonBeneficialOwnersNotSignedSingle }}
              </div>
            }
          </div>
        }
      }
    }
  }

  <div class="form-group" [hidden]="beneficialOwnersSignsErrorMessageHidden">
    <app-validation-error
      [control]="formGroup"
      [customErrors]="customSignErrors"
    />
  </div>
</div>
